import {
  IconMapPin,
  IconSettings,
  IconSoup,
  IconTicket,
} from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import type { PanelNavigationLink } from "@/features/panel/types";

const ICON_STROKE_WIDTH = 1.5;
const ICON_CLASS_NAME = "size-6 shrink-0";

export const getAccountMenuLinks = (): PanelNavigationLink[] => {
  const t = useTranslations("panel.navigation");

  return [
    {
      href: "/panel/diets",
      icon: (
        <IconSoup className={ICON_CLASS_NAME} strokeWidth={ICON_STROKE_WIDTH} />
      ),
      label: t("home"),
      testData: "account-menu-diets",
    },
    {
      href: "/panel/discounts",
      icon: (
        <IconTicket
          className={ICON_CLASS_NAME}
          strokeWidth={ICON_STROKE_WIDTH}
        />
      ),
      label: t("discounts"),
      testData: "account-menu-discounts",
    },
    {
      href: "/panel/my-addresses",
      icon: (
        <IconMapPin
          className={ICON_CLASS_NAME}
          strokeWidth={ICON_STROKE_WIDTH}
        />
      ),
      label: t("myAddresses"),
      testData: "account-menu-addresses",
    },
    {
      href: "/panel/my-account",
      icon: (
        <IconSettings
          className={ICON_CLASS_NAME}
          strokeWidth={ICON_STROKE_WIDTH}
        />
      ),
      label: t("myAccount"),
      testData: "account-menu-my-account",
    },
  ];
};
